/*
  Mad Olive - quantity selector inline with the Add to Cart button.

  The Expanse product template renders the quantity_selector and buy_buttons
  blocks stacked, so the quantity stepper sits on its own line and the Add to
  Cart button sits below the personalization fields. This module drops the
  stepper into the same flex row as the button so they sit side by side, with
  the row spanning the same full width the buy area already had.

  The personalization app (Customily / Zepto) injects its panel (div.inject)
  immediately before the Add to Cart button. Because the button now lives in our
  row, the panel gets injected INTO the row. Rather than fight that, we let it
  sit there and use flex-wrap + `order` in CSS: the panel is forced onto its own
  full-width line ABOVE, and the stepper + button wrap together onto the line
  below. So the on-screen result is:

      [ personalization panel, full width ]
      [ stepper ][ Add to Cart -> fills width ]

  A MutationObserver re-applies the arrangement if the app or a variant change
  re-renders the form. Once the stepper and button both live in the row the
  observer is a no-op (the app is free to inject its panel between them), so it
  never loops or fights the app.
*/
(function () {
  var ROW_ID = 'mo-qty-row';
  var STYLE_ID = 'mo-buy-layout-styles';
  var CSS =
    '#' + ROW_ID + '{display:flex;flex-wrap:wrap;align-items:flex-end;gap:12px;margin:0 0 12px;}' +
    '#' + ROW_ID + ' > block-quantity-selector,#' + ROW_ID + ' > .product__quantity{order:2;flex:0 0 auto;margin:0;}' +
    '#' + ROW_ID + ' > .add-to-cart{order:2;flex:1 1 auto;width:auto;margin:0;}' +
    // Anything else the app injects into the row (its personalization panel) gets
    // its own full-width line above the stepper/button line.
    '#' + ROW_ID + ' > *:not(block-quantity-selector):not(.product__quantity):not(.add-to-cart)' +
    '{order:1;flex:1 1 100%;width:100%;margin:0;}';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function findForm() {
    return document.querySelector('form.shopify-product-form, form[action*="/cart/add"]');
  }

  function arrange() {
    var form = findForm();
    if (!form) return;
    var scope = form.closest('[id^="shopify-section"]') || document;
    var qty = scope.querySelector('block-quantity-selector, .product__quantity');
    var btn = form.querySelector('.add-to-cart');
    if (!qty || !btn) return;

    var row = document.getElementById(ROW_ID);

    // Done once both live in the row: the app may inject its panel in between and
    // CSS lays it out, so we leave the DOM alone and never fight the app.
    if (row && row.contains(qty) && row.contains(btn)) return;

    if (!row) {
      row = document.createElement('div');
      row.id = ROW_ID;
    }

    // Position the row where the button lives, then make sure the stepper and the
    // button are both inside it (stepper first, button last among our nodes).
    if (btn.parentNode !== row) btn.parentNode.insertBefore(row, btn);
    if (qty.parentNode !== row) row.insertBefore(qty, row.firstChild);
    row.appendChild(btn);
  }

  function init() {
    injectStyles();
    var form = findForm();
    if (!form) return;
    arrange();

    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        arrange();
      });
    });
    obs.observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
